import type { Element } from 'hast';

/**
 * Detect block vs. inline code without relying on the `inline` prop, which
 * `react-markdown` v10 dropped. A code node is a block when the AST attached
 * a `language-*` className (fenced block with a language) or when the text
 * contains a newline (multi-line plain code).
 */
export function isBlockCode(className: string | undefined, text: string): boolean {
  return Boolean(className?.startsWith('language-')) || text.includes('\n');
}

/**
 * Does this `pre` node wrap a `code` element?
 *
 * A fenced block parses to `<pre><code>`, and the `code` override renders the
 * whole block shell, so the `pre` around it collapses to a fragment. Raw HTML
 * can also carry a bare `<pre>` of preformatted text, which needs a real
 * element to keep its whitespace.
 */
export function wrapsCodeElement(node: Element | undefined): boolean {
  return Boolean(
    node?.children.some((child) => child.type === 'element' && child.tagName === 'code'),
  );
}
